<template>
  <div id="app">
    <!--头部-->
    <!--<myHeader v-show="headerShow"></myHeader>-->
    <router-view></router-view>

    <!--底部-->
    <!--<myFooter v-show="footerShow"></myFooter>-->
  </div>
</template>
//<script>
//import myHeader from './components/header'
//import myFooter from './components/myFooter'
//import { mapGetters,mapActions} from 'vuex'
////      
export default {
//  computed:mapGetters([
//      "headerShow",
//      "footerShow"
//  ]),
//  watch:{
//      $route(to,from){
//          var path = to.path;
//          if(path.indexOf('/home')==0 || path == '/login'|| path == '/forget'|| path == '/register'){
//              if(path.indexOf("/home") != 0){
//                  this.$store.dispatch("hideHeader");
//              }    
//              this.$store.dispatch("hideFooter");
//          }
//          else{
//              this.$store.dispatch("showFooter");
//              this.$store.dispatch("showHeader");
//              
//          }
//      }
//  },
    name: 'App',
//  components: {
//      myHeader,
//      myFooter
//  },
//  created () {
//      //在页面加载时读取sessionStorage里的状态信息
//      if (sessionStorage.getItem("store") ) {
//          this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
//      } 
//
//      //在页面刷新时将vuex里的信息保存到sessionStorage里
//      window.addEventListener("beforeunload",()=>{
//          sessionStorage.setItem("store",JSON.stringify(this.$store.state))
//      })
//  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue